import { ActionIcon, Group, Tooltip } from '@mantine/core'
import useCurrentRoom from '../hooks/useCurrentRoom'
import useQueueTrack from '../hooks/useQueueTrack'

export default function SearchTrackControls(props) {
    const { track, isFirstRow } = props
    const room = useCurrentRoom()
    const queueTrack = useQueueTrack(room?.id)

    const canQueueTrack = room && (
        (!track.userId && !track.roomId) ||
        (track.roomId === room.id)
    )

    function handleQueueClick() {
        queueTrack(track)
    }

    return (
        <Group gap="xs" wrap="nowrap">
            {canQueueTrack && (
                <Tooltip label="Add to room's play queue" openDelay={1000} zIndex={2100}>
                    <ActionIcon
                        variant="subtle"
                        color="blue"
                        size="lg"
                        onClick={handleQueueClick}
                        aria-label="Add to queue"
                        data-tour={isFirstRow ? 'add-to-queue-first' : undefined}
                    >
                        <span className="material-symbols-outlined">playlist_add</span>
                    </ActionIcon>
                </Tooltip>
            )}
        </Group>
    )
}
